@if (isErrorRequest()) {
  <app-error-component [errorMessage]="errorMessage()" />
} @else if (!offer()) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
    <p class="spinner-message">This may take a moment, please wait...</p>
  </div>
} @else {
  <mat-card class="detail-card">
    @if (offer()?.photos?.length) {
      <app-slider [photos]="getParsedPhotos(offer())"></app-slider>
    } @else {
      <div class="no-img-box">
        <img
          src="../../../../assets/no-img.png"
          alt="no-photo"
          class="no-img-box__img" />
        <div class="no-img-box__text">Photo not provided.</div>
      </div>
    }

    <mat-card-header>
      <mat-card-title>{{ offer()!.title }}</mat-card-title>
      <mat-card-subtitle>{{ offer()!.address }}</mat-card-subtitle>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
      <div class="detail-info">
        <div class="list-features">
          <div><b>Distance from home:</b></div>
          <div class="list-features__item">
            <span class="list-features__item_num">
              {{ offer()!.distanceFromHome | number: '1.2-2' }} km</span
            >
            <span class="list-features__item_p"> away from home</span>
          </div>
        </div>
        @if (offer()?.features?.length) {
          <div class="list-features">
            <div><b>Features:</b></div>
            <div
              class="offer-card__features"
              *ngIf="offer()?.features as offer">
              <ng-container *ngFor="let feature of localFeatureIcons">
                <span *ngIf="hasFeature(offer, feature.key)">
                  {{ feature.icon }} {{ feature.label }}
                </span>
              </ng-container>
            </div>
          </div>
        }
        @if (offer()?.description?.length) {
          <p class="detail-desc">
            <b>Description:</b>
            {{ offer()?.description }}
          </p>
        }
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button
        class="accent-btn"
        mat-raised-button
        color="accent"
        (click)="backToMainPage.emit()">
        Back
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="reserve.emit(offer()!.id)">
        Reserve
      </button>
    </mat-card-actions>
  </mat-card>
}
